import React from 'react'

const Manual_nota_credito_digifact = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Guía rápida para emitir una Nota de Crédito
        </h2>
        <iframe
          src="https://scribehow.com/embed/Guia_rapida_para_emitir_una_Nota_de_Credito__qaCneREiTIG0mdxF7anu3w?as=scrollable"
          className="scribe-iframe-general-183"
          width="100%"
          height="6500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_nota_credito_digifact
